export const GetSQLBackup = () => {
    let files = require.context('../../backup', false);
    return files.keys().map(file => files(file));
}